export default __webpack_public_path__ + "static/media/6、首页气泡果汁.15421911.jpg";